/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createWeakMixingAngle } from '../../factoriesAny.js';
export var weakMixingAngleDependencies = {
  BigNumberDependencies,
  createWeakMixingAngle
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesWeakMixingAngle.generated.js
// module id = 3wvT
// module chunks = 3